// EINE Lesart fuer "ist dieses angemeldete Konto das freigegebene?" (01.11.2026).
//
// Genutzt von drei Stellen, die frueher je eigene Regeln hatten:
//   - Client, Konto-Anmeldung im Partnerfenster (src/components/panels/partnerKontoAnmeldung.ts),
//   - Desktop-App, Bestaetigung einer Konto-Kachel bei der Buehnenaufnahme (electron/stage-capture.cjs),
//   - Server, Gegenpruefung der von der App gemeldeten Identitaet (server/routes/stage-capture.ts).
// Die Datei liegt unter electron/, weil nur dieser Ordner in die Desktop-App gepackt wird
// (electron-builder*.json "files"); Client und Server importieren sie von hier.
//
// Regel:
//   - Hat das Konto eine E-Mail, zaehlt NUR die E-Mail (ohne Gross-/Kleinschreibung, getrimmt).
//     Eine passende Kennung hilft dann nicht.
//   - Hat es keine E-Mail (Partner-Nutzer wie `mo-allagha`), muss die Kennung (user.id der
//     Ziel-App) EXAKT dem Freigabe-Eintrag entsprechen: keine Faltung der Schreibweise, weil
//     Kennungen sich nur in der Schreibweise unterscheiden koennen.
//   - Ein Freigabe-Eintrag mit "@" ist eine E-Mail und wird nie ueber eine Kennung erfuellt:
//     ein Konto ohne E-Mail, dessen Kennung zufaellig wie eine fremde E-Mail aussieht, gilt
//     nicht als dieses Konto.
//   - Leerer Freigabe-Eintrag oder leere Identitaet: nie.

/** @param {{ id?: unknown, email?: unknown } | null | undefined} u @param {unknown} freigabe */
export function passtZuFreigabe(u, freigabe) {
  const soll = typeof freigabe === 'string' ? freigabe.trim() : '';
  if (!soll) return false;
  const email = u && typeof u.email === 'string' ? u.email.trim() : '';
  if (email) return email.toLowerCase() === soll.toLowerCase();
  const kennung = u && typeof u.id === 'string' ? u.id : '';
  return !soll.includes('@') && kennung !== '' && kennung === soll;
}
